export const totalProductsSold = {
	label: "Total de produtos vendidos",
};
